<div class="chat-bubble" (click)="toggleChat()">
  @if (!isChatOpen) {
  <fa-icon [icon]="faCommentDots"></fa-icon>
  } @else {
  <fa-icon [icon]="faTimes"></fa-icon>
  }
</div>
<app-chat-window [hidden]="!isChatOpen" (closeChat)="toggleChat()"></app-chat-window>
